import { Directive } from '@angular/core';

@Directive({ selector: '[bpAlertTitle]', standalone: true, host: { class: 'font-semibold' } })
export class BpAlertTitleDirective {}

@Directive({ selector: '[bpAlertIcon]', standalone: true })
export class BpAlertIconDirective {}
